import { render, staticRenderFns } from "./supervisionNotice.vue?vue&type=template&id=24deee42&"
import script from "./supervisionNotice.vue?vue&type=script&lang=js&"
export * from "./supervisionNotice.vue?vue&type=script&lang=js&"
import style0 from "./supervisionNotice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports